/**
 * @pageName Posts
 * @slotType dashboard menu plugin
 */
export type EditPostMainMoreActionsMenuParams = {};
